export interface ISharpenTrack {
  id: number;
  title: string;
  description?: string;
  modules: number[];
}

export interface ISharpenModule {
  id: number;
  title: string;
  description?: string;
  intro: ISharpenContentNode[];
  body: {
    id: number;
    body: ISharpenContentNode[];
    mind_sharpener_image_1?: string
    mind_sharpener_image_2?: string
  };
  outro: ISharpenContentNode[];
  banner_image?: string;
}

export interface ISharpenContentNode {
  type: SharpenContentType;
  value: string | number | ISharpenVideo | ISharpenQuotation;
  id: string;
}

export interface ISharpenVideo {
  video: number;
  description?: string;
}

export interface ISharpenQuotation {
  quote: string;
  author: string;
}

export interface ISharpenPagedResponse<T> {
  count: number;
  next: string;
  previous: string;
  results: T[];
}

export interface ISharpenVideoData {
  id: number;
  title: string;
  description?: string;
  transcript?: string;
  file: string;
  thumbnail: string;
  duration: string;
  primary_protective_factor?: string;
  secondary_protective_factor?: string;
  primary_user_story?: string;
  secondary_user_story?: string;
  age_group?: string;
  gender?: string;
  color_theme?: string;
  partne?: number;
  created_at: string;
  updated_at: string;
}

export enum SharpenContentType {
  HEADING = 'section_heading',
  PARAGRAPH = 'paragraph',
  QUOTATION = 'quotation',
  IMAGE = 'image',
  VIDEO = 'video_with_description',
}